import {
  CREATE_SECURITY_KEYS_API,
  DELETE_SECURITY_KEYS_API,
  GET_SECURITY_KEYS_DETAIL_API,
  SEARCH_SECURITY_KEYS_API,
  UPDATE_SECURITY_KEYS_API
} from '~/constants/APIs'
import {
  ISecurityKeyData,
  ISecurityKeyForm,
  ISecurityKeySearchForm,
  ISecurityKeySearchResponse
} from '~/models'

import axiosClient from './axiosClient'

export const securityKeyApis = {
  searchSecurityKeys: (params: ISecurityKeySearchForm) => {
    return axiosClient.get(SEARCH_SECURITY_KEYS_API, {
      params
    }) as unknown as ISecurityKeySearchResponse
  },

  createSecurityKey: (data: ISecurityKeyForm) =>
    axiosClient.post(CREATE_SECURITY_KEYS_API, data),

  updateSecurityKey: (data: ISecurityKeyForm) =>
    axiosClient.put(UPDATE_SECURITY_KEYS_API + data.serialNumber, data),

  deleteSecurityKey: (data: any) =>
    axiosClient.delete(DELETE_SECURITY_KEYS_API, { data }),

  getSecurityKeyDetail: (serialNumber: string) =>
    axiosClient.get(
      GET_SECURITY_KEYS_DETAIL_API + serialNumber
    ) as unknown as ISecurityKeyData
}
